/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const readmoreBtn = document.querySelectorAll(".readmoreBtn");

const toggleText = (i) => {
  const readmoreText = document.querySelectorAll(".more");
  const dots = document.querySelectorAll(".dots");

  if (dots[i].style.display === "none") {
    dots[i].style.display = "inline";
    readmoreBtn[i].innerHTML = window.languages.readmoreBtn;
    readmoreText[i].style.display = "none";
  } else {
    dots[i].style.display = "none";
    readmoreBtn[i].innerHTML = window.languages.readLessBtn;
    readmoreText[i].style.display = "inline";
  }

};
if (readmoreBtn.length !== 0) {
  readmoreBtn[0].addEventListener("click", () => {
    toggleText(0);
  });
  readmoreBtn[1].addEventListener("click", () => {
    toggleText(1);
  });
}


const variantListItems = document.querySelectorAll(".SizeSwatchList>.HorizontalList__Item");
const globalVariantList = window.product.variant;

globalVariantList?.forEach((element, index) => {
  if (element.available === false) {
    variantListItems[index].classList.add("line-through")
  }
});


/* terms and conditions */
const termsOverlay = document.querySelector('.terms-overlay');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');

function showTerms() {
  termsOverlay.classList.add('terms-overlay--active');
  termsContent.classList.add('terms-content-wrapper--active');
}

function hideTerms() {
  termsOverlay.classList.remove('terms-overlay--active');
  termsContent.classList.remove('terms-content-wrapper--active');
}

function validateTerms(e) {
  e.preventDefault();
  const cartTerms = document.querySelector('input[name=checkbox]');

  if (cartTerms.checked) {
    window.location = '/checkout';
  } else {
    showTerms();
  }
}

termsOverlay?.addEventListener('click', () => {
  hideTerms();
});

termsAccept?.addEventListener('click', () => {
  window.location = '/checkout';
});

termsDeny?.addEventListener('click', () => {
  hideTerms();
});

const productPage = window.location.href.includes('/products/');

if (productPage) {
  var node = document.querySelector('[data-countdown]');
  var getWeekday = window.countdown.times;

  var now = new Date();
  var countdownFrom = new Date();

  var currentDay = getWeekday[now.getDay()].split(':');
  var clocktimer;

  function checkDist () {
    currentDay = getWeekday[countdownFrom.getDay()].split(':');

    countdownFrom.setHours(+currentDay[0]);
    countdownFrom.setMinutes(+currentDay[1]);
    countdownFrom.setSeconds(0);

    now = new Date();
    const dist = countdownFrom.getTime() - now;

    return dist < 0
  }

  function getDisplayTimer() {
    currentDay = getWeekday[countdownFrom.getDay()].split(':');

    countdownFrom.setHours(+currentDay[0]);
    countdownFrom.setMinutes(+currentDay[1]);
    countdownFrom.setSeconds(0);

    now = new Date();
    const dist = countdownFrom.getTime() - now;
    if (dist > 0) {
      const daysFloor = Math.floor(dist / (1000 * 60 * 60 * 24));
      const hoursFloor = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesFloor = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      const secondsFloor = Math.floor((dist % (1000 * 60)) / 1000);

      if (daysFloor > 0) {
        node.innerHTML = window.countdown.next_day_html;
        const days = node.querySelector('[data-days]');
        days.textContent = `${daysFloor}${window.countdown.days}`;
      } else {
        node.innerHTML = window.countdown.same_day_html;
      }
      const hours = node.querySelector('[data-hours]');
      const minutes = node.querySelector('[data-minutes]');
      const seconds = node.querySelector('[data-seconds]');
      hours.textContent = `${hoursFloor}${window.countdown.hours}`;
      minutes.textContent = `${minutesFloor}${window.countdown.minutes}`;
      seconds.textContent = `${secondsFloor}${window.countdown.seconds}`;
    }
  }

  const currentDayTimeIsEmpty = !getWeekday[countdownFrom.getDay()];

  const getNextAvailable = () => {
    const check = !getWeekday[countdownFrom.getDay()];
    if (check) {
      countdownFrom.setDate(countdownFrom.getDate() + 1);
      getNextAvailable();
    }
  };

  if (currentDayTimeIsEmpty) {
    getNextAvailable();
  }

  if (checkDist()) {
    countdownFrom.setDate(countdownFrom.getDate() + 1);
    countdownFrom.setHours(0);
    countdownFrom.setMinutes(0);
    countdownFrom.setSeconds(0);
    getNextAvailable()
  }

  clocktimer = setInterval(() => {
    getDisplayTimer();
  }, 1000);
}

/**
 * Show points based on variant
 */

if (window.location.pathname.includes('/products/')) {
  document.addEventListener('variant:changed', function (evt) {
    var variant = evt.detail.variant;
    var pointsElm = document.querySelector(`.product-points[data-variant="${variant.id}"]`);
    var pointsElmArr = document.querySelectorAll(`.product-points[data-variant]`);

    pointsElmArr.forEach(i => i.classList.add('u-visually-hidden'));
    if (pointsElm) {
      pointsElm.classList.remove('u-visually-hidden');
    }
  })
}

/**
 * Gift wrapping
 */

theme.cartUtils = {
  updateCart: function (callback = null) {
    fetch(`/cart.js?t=${Date.now()}`, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.json())
      .then(cart => {
        theme.cartData = cart
        if (callback) {
          callback()
        }
      });
  },

  addToCart: function (formData, callback = null) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then((data) => {
        if (callback) {
          callback(data)
        }
        return data;
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        if (callback) {
          callback(null, error);
        }
        throw error;
      });
  },

  changeItem: function (key, qty) {
    return fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      body: JSON.stringify({id: key, quantity: qty}),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => response.json())
  }
};

/**
 * Gift wrapping functionality
 */
(function() {
  'use strict';

  console.log('🎁 Gift wrapping module starting...');

  let isInitialized = false;
  let currentGiftId = null;

  function initGiftWrap() {
    const gift = document.querySelector("#is-a-gift");
    if (!gift) {
      console.log('🎁 No gift wrap element found, will check after cart refresh');
      return;
    }

    const gift_id = +gift.dataset.id;

    // Prevent duplicate initialization
    if (isInitialized && currentGiftId === gift_id) {
      console.log('🎁 Already initialized for gift ID:', gift_id);
      return;
    }

    console.log('🎁 Gift wrap ID:', gift_id);
    currentGiftId = gift_id;
    isInitialized = true;

    // Initialize gift wrap functionality
    setupGiftWrap(gift_id);
  }

  function setupGiftWrap(gift_id) {

    // Simple helper functions
    const getGiftWrapInput = () => document.querySelector('[name="attributes[gift-wrapping]"]');
    const hasEligibleItems = () => theme.cartData?.items?.some(i => i.id !== gift_id) || false;
    const hasGiftWrapInCart = () => theme.cartData?.items?.some(i => i.id === gift_id) || false;

    // Main function: Add 1 gift wrap if checked + has items, remove if not
    function manageGiftWrap() {
      // Check if cart data is available
      if (!theme.cartData) {
        console.log('🎁 ⏳ Cart data not available yet, updating...');
        theme.cartUtils.updateCart(() => {
          console.log('🎁 ✅ Cart data loaded, retrying gift wrap management');
          manageGiftWrap();
        });
        return;
      }

      const isChecked = getGiftWrapInput()?.checked;
      const shouldHave = isChecked && hasEligibleItems();
      const currentlyHas = hasGiftWrapInCart();

      console.log('🎁 Gift wrap:', {
        isChecked,
        shouldHave,
        currentlyHas,
        cartItems: theme.cartData?.items?.length || 0
      });

      if (shouldHave && !currentlyHas) {
        console.log('🎁 ➕ Adding gift wrap');
        theme.cartUtils.addToCart({id: gift_id, quantity: 1}, (data) => {
          console.log('🎁 ✅ Gift wrap added, refreshing cart');
          theme.cartUtils.updateCart(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
        });
      } else if (!shouldHave && currentlyHas) {
        console.log('🎁 ❌ Removing gift wrap');
        theme.cartUtils.changeItem(gift_id.toString(), 0).then((cart) => {
          console.log('🎁 ✅ Gift wrap removed, refreshing cart');
          theme.cartData = cart;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      } else {
        console.log('🎁 ✅ Gift wrap state correct');
      }
    }

    // Event handler for checkbox changes
    function handleCheckboxChange(event) {
      console.log('🎁 📋 Checkbox changed:', event.target.checked);
      theme.cartUtils.updateCart(manageGiftWrap);
    }

    // Initialize
    function initEvents() {
      const input = getGiftWrapInput();
      if (input) {
        input.removeEventListener("change", handleCheckboxChange);
        input.addEventListener("change", handleCheckboxChange);
        console.log('🎁 ✅ Event listeners attached');
      } else {
        console.log('🎁 ⚠️ Gift wrap input not found for events');
      }
    }

    // Setup
    initEvents();

    // Always try to manage gift wrap, even with empty cart
    console.log('🎁 🚀 Running initial gift wrap check...');
    manageGiftWrap();

    // Event listeners
    document.addEventListener('product:added', (evt) => {
      if (evt.detail.variant !== gift_id) {
        console.log('🎁 ➕ Product added, checking gift wrap');
        theme.cartUtils.updateCart(manageGiftWrap);
      }
    });

    console.log('🎁 ✅ Gift wrap setup complete!');
  }

  // Try initial setup
  initGiftWrap();

  // Listen for cart refresh events globally to catch when element becomes available
  document.addEventListener('cart:refreshed', () => {
    console.log('🎁 🔄 Global cart refresh - checking for gift wrap element');

    // Reset initialization flag to allow re-initialization after cart refresh
    isInitialized = false;
    currentGiftId = null;

    // Try to initialize again
    initGiftWrap();
  });
})();

/**
 * Emballageafgift (Packaging Tax) functionality
 * Automatically adds/removes the mandatory packaging tax product
 */
(function() {
  'use strict';

  function initEmballageafgift() {
    const cartItemList = document.querySelector('.Cart__ItemList[data-emballageafgift-product-id]');
    if (!cartItemList) {
      return;
    }

    const emballageafgiftProductId = parseInt(cartItemList.dataset.emballageafgiftProductId);
    const emballageafgiftVariantId = parseInt(cartItemList.dataset.emballageafgiftVariantId);

    if (!emballageafgiftProductId || !emballageafgiftVariantId) {
      console.log('📦 Emballageafgift: Product not configured');
      return;
    }

    function manageEmballageafgift() {
      if (!theme.cartData) {
        theme.cartUtils.updateCart(() => {
          manageEmballageafgift();
        });
        return;
      }

      // Helper function to check if an item is a gift card
      function isGiftCard(item) {
        const handle = (item.handle || '').toLowerCase();
        const productTitle = (item.product_title || '').toLowerCase();
        const productType = (item.product_type || '').toLowerCase();
        
        return handle.includes('gavekort') || 
               productTitle.includes('gavekort') || 
               productTitle.includes('gift card') ||
               productType === 'gift card';
      }

      // Count non-emballageafgift items, excluding gift cards
      const regularItems = theme.cartData.items.filter(item => 
        item.product_id !== emballageafgiftProductId && !isGiftCard(item)
      );
      const emballageafgiftItems = theme.cartData.items.filter(item => item.product_id === emballageafgiftProductId);
      const shouldHaveEmballageafgift = regularItems.length > 0;

      if (shouldHaveEmballageafgift) {
        // Should have exactly 1 emballageafgift item with quantity 1
        if (emballageafgiftItems.length === 0) {
          // No emballageafgift item, add one
          console.log('📦 ➕ Adding emballageafgift');
          theme.cartUtils.addToCart({
            id: emballageafgiftVariantId,
            quantity: 1,
            properties: {
              '_emballageafgift': 'true'
            }
          }, (data) => {
            theme.cartUtils.updateCart(() => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
          });
        } else if (emballageafgiftItems.length > 1) {
          // Multiple emballageafgift items, remove all but the first one
          console.log('📦 🔧 Multiple emballageafgift items found, removing duplicates');
          const itemsToRemove = emballageafgiftItems.slice(1);
          let removedCount = 0;
          itemsToRemove.forEach(item => {
            theme.cartUtils.changeItem(item.key, 0).then(() => {
              removedCount++;
              if (removedCount === itemsToRemove.length) {
                // Also ensure the remaining one has quantity 1
                const remainingItem = emballageafgiftItems[0];
                if (remainingItem.quantity !== 1) {
                  theme.cartUtils.changeItem(remainingItem.key, 1).then(() => {
                    theme.cartUtils.updateCart(() => {
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    });
                  });
                } else {
                  theme.cartUtils.updateCart(() => {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                  });
                }
              }
            });
          });
        } else {
          // Exactly one emballageafgift item, ensure quantity is 1
          const emballageafgiftItem = emballageafgiftItems[0];
          if (emballageafgiftItem.quantity !== 1) {
            console.log('📦 🔧 Setting emballageafgift quantity to 1');
            theme.cartUtils.changeItem(emballageafgiftItem.key, 1).then((cart) => {
              theme.cartData = cart;
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
          }
        }
      } else {
        // Should not have emballageafgift, remove all instances
        if (emballageafgiftItems.length > 0) {
          console.log('📦 ❌ Removing emballageafgift');
          let removedCount = 0;
          emballageafgiftItems.forEach(item => {
            theme.cartUtils.changeItem(item.key, 0).then(() => {
              removedCount++;
              if (removedCount === emballageafgiftItems.length) {
                theme.cartUtils.updateCart(() => {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                });
              }
            });
          });
        }
      }
    }

    // Initial check
    manageEmballageafgift();

    // Listen for cart changes
    document.addEventListener('cart:refreshed', () => {
      setTimeout(() => {
        manageEmballageafgift();
      }, 100);
    });

    // Listen for product additions
    document.addEventListener('product:added', () => {
      setTimeout(() => {
        manageEmballageafgift();
      }, 100);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmballageafgift);
  } else {
    initEmballageafgift();
  }

  // Also initialize after cart refresh
  document.addEventListener('cart:refreshed', () => {
    setTimeout(() => {
      initEmballageafgift();
    }, 200);
  });
})();

/**
 * Per-item gift wrapping functionality
 */
(function() {
  'use strict';

  function initPerItemGiftWrap() {
    const cartItemList = document.querySelector('.Cart__ItemList[data-giftwrap-product-id]');
    if (!cartItemList) {
      console.log('🎁 Per-item gift wrap: Cart item list not found');
      return;
    }

    const giftwrapProductId = cartItemList.dataset.giftwrapProductId;
    const giftwrapVariantId = cartItemList.dataset.giftwrapVariantId;

    if (!giftwrapProductId || !giftwrapVariantId || giftwrapProductId === 'null' || giftwrapVariantId === 'null') {
      console.log('🎁 Per-item gift wrap: Giftwrap product not configured', { giftwrapProductId, giftwrapVariantId });
      return;
    }

    console.log('🎁 Per-item gift wrap: Initializing', { giftwrapProductId, giftwrapVariantId });

    // Setup event listeners for all giftwrap checkboxes
    function setupCheckboxes() {
      const checkboxes = document.querySelectorAll('.CartItem__GiftWrapCheckbox');
      console.log('🎁 Per-item gift wrap: Found checkboxes', checkboxes.length);
      
      checkboxes.forEach((checkbox, index) => {
        // Remove any existing event listeners by cloning
        const newCheckbox = checkbox.cloneNode(true);
        checkbox.parentNode.replaceChild(newCheckbox, checkbox);
        
        newCheckbox.addEventListener('change', function(e) {
          console.log('🎁 Per-item gift wrap: Checkbox changed', {
            checked: this.checked,
            variantId: this.dataset.variantId,
            productTitle: this.dataset.productTitle
          });
          handleGiftWrapChange(this, giftwrapProductId, giftwrapVariantId);
        });
        
        console.log('🎁 Per-item gift wrap: Event listener attached to checkbox', index);
      });
    }

    // Handle checkbox change - only for adding giftwrap
    function handleGiftWrapChange(checkbox, giftwrapProductId, giftwrapVariantId) {
      // Only handle checked state (adding)
      if (!checkbox.checked) {
        // Unchecking is handled by the remove link, just refresh to update checkbox state
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      // Prevent multiple rapid clicks
      if (checkbox.disabled) {
        return;
      }

      const variantId = checkbox.dataset.variantId;
      const productTitle = checkbox.dataset.productTitle;
      const variantTitle = checkbox.dataset.variantTitle || '';
      const lineItemKey = checkbox.dataset.lineItemKey;

      // Disable checkbox during operation
      checkbox.disabled = true;

      // Add giftwrap product with properties
      // Properties without '_' prefix will be visible in checkout
      const formData = {
        id: parseInt(giftwrapVariantId),
        quantity: 1,
        properties: {
          '_giftwrap_for_product': productTitle,
          '_giftwrap_for_variant': variantId,
          '_giftwrap_for_variant_title': variantTitle,
          '_giftwrap_for_line_item': lineItemKey,
          'Gaveindpakning til': productTitle
        }
      };

      theme.cartUtils.addToCart(formData, (data, error) => {
        checkbox.disabled = false;
        
        if (error) {
          console.error('🎁 Per-item gift wrap: Error adding to cart', error);
          checkbox.checked = false;
          return;
        }
        
        theme.cartUtils.updateCart(() => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      });
    }

    // Initial setup
    setupCheckboxes();
  }

  // Try initial setup when DOM is ready
  function tryInit() {
    setTimeout(() => {
      initPerItemGiftWrap();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // Cleanup orphaned giftwrap items (when main product is removed)
  function cleanupOrphanedGiftwrap(giftwrapProductId) {
    if (!theme.cartData || !giftwrapProductId) {
      return;
    }

    // Get all variant IDs currently in cart (excluding giftwrap items)
    const cartVariantIds = new Set();
    theme.cartData.items.forEach(item => {
      if (item.product_id.toString() !== giftwrapProductId.toString()) {
        cartVariantIds.add(item.variant_id.toString());
      }
    });

    // Find orphaned giftwrap items
    const orphanedGiftwrapItems = [];
    theme.cartData.items.forEach(item => {
      if (item.product_id.toString() === giftwrapProductId.toString()) {
        // Check if this giftwrap item has a property linking it to a variant
        const giftwrapForVariant = item.properties && item.properties._giftwrap_for_variant;
        if (giftwrapForVariant) {
          const variantIdStr = giftwrapForVariant.toString();
          // If the associated variant is no longer in cart, mark for removal
          if (!cartVariantIds.has(variantIdStr)) {
            orphanedGiftwrapItems.push(item);
          }
        }
      }
    });

    // Remove orphaned giftwrap items
    if (orphanedGiftwrapItems.length > 0) {
      console.log('🎁 Per-item gift wrap: Found orphaned giftwrap items to remove', orphanedGiftwrapItems.length);
      
      // Remove items one by one
      let removedCount = 0;
      orphanedGiftwrapItems.forEach(giftwrapItem => {
        theme.cartUtils.changeItem(giftwrapItem.key, 0).then(() => {
          removedCount++;
          if (removedCount === orphanedGiftwrapItems.length) {
            // All orphaned items removed, refresh cart
            theme.cartUtils.updateCart(() => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
          }
        }).catch(error => {
          console.error('🎁 Per-item gift wrap: Error removing orphaned giftwrap', error);
          removedCount++;
          if (removedCount === orphanedGiftwrapItems.length) {
            theme.cartUtils.updateCart(() => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
          }
        });
      });
    }
  }

  // Re-setup after cart refresh
  document.addEventListener('cart:refreshed', () => {
    console.log('🎁 Per-item gift wrap: Cart refreshed, re-initializing');
    
    // Cleanup orphaned giftwrap items first
    const cartItemList = document.querySelector('.Cart__ItemList[data-giftwrap-product-id]');
    if (cartItemList) {
      const giftwrapProductId = cartItemList.dataset.giftwrapProductId;
      if (giftwrapProductId && giftwrapProductId !== 'null') {
        theme.cartUtils.updateCart(() => {
          cleanupOrphanedGiftwrap(giftwrapProductId);
        });
      }
    }
    
    setTimeout(() => {
      initPerItemGiftWrap();
    }, 200);
  });

  // Also listen for cart:refresh event (before refresh happens)
  document.addEventListener('cart:refresh', () => {
    console.log('🎁 Per-item gift wrap: Cart refresh event detected');
  });
})();

/**
 * Linked products show more
 */
const showMore = document.querySelector('#linked_show_more');
if (showMore) {
  showMore.addEventListener('click', function () {
    showMore.parentElement.style.maxHeight = '999px';
    showMore.parentElement.style.maxWidth = '999px';
    showMore.remove();
  })
}

